import React from "react"
import { Tooltip } from "@radix-ui/react-tooltip"
import { FileTextIcon, TruckIcon } from "lucide-react"

import { ExtendedAddressRO } from "@/lib/storefront/addresses/address"
import { TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/components/tooltip"
import { cn } from "@/components/ui/helpers/utils"
import { ClassValue } from "clsx"

interface AddressFieldsProps {
  address: ExtendedAddressRO
  isB2B: boolean
  className?: string
  showEligibleIcons?: {
    invoiceAddressTooltip: string
    shippingAddressTooltip: string
  }
}

interface optionalInput {
  value: any
  classname?: ClassValue|string
}

const OptionalSpan = ({ value, classname = "" }:optionalInput) =>
  value ? <span className={cn("text-nowrap", classname)}>{value}</span> : null
const OptionalDiv = ({ value, classname = "" }:optionalInput) =>
  value ? <div className={cn("text-nowrap", classname)}>{value}</div> : null

function AddressFieldsB2B({ a }: { a: ExtendedAddressRO }) {
  return (
    <>
      {a && (
        <>
          <div className="flex flex-col items-start gap-y-px">
            {/*    <div className="flex flex-row gap-x-[0.2rem]">
        <OptionalSpan value={a.title} />
        <OptionalSpan value={a.aristocraticTitle} />
        <OptionalSpan value={a.jobTitle} />
        <OptionalSpan value={a.honorific} />
        <OptionalSpan value={a.firstName} />
        <OptionalSpan value={a.secondName} />
        <OptionalSpan value={a.lastName} />
        <OptionalSpan value={a.secondLastName} />
      </div>*/}
            <OptionalDiv value={a.companyName1} />
            <OptionalDiv value={a.companyName2} />
            <OptionalDiv value={a.addressLine1} />
            <OptionalDiv value={a.addressLine2} />
            <div className="flex flex-row gap-x-[0.2rem]">
              {/*<OptionalSpan value={a.countryCode} />*/}
              <OptionalSpan value={a.postalCode} />
              <OptionalSpan value={a.city} />
            </div>
            <OptionalSpan value={a.country} />
          </div>

          <div className="flex flex-col items-start gap-y-px">
            <div className="flex flex-row flex-wrap gap-x-[0.2rem]">
              <OptionalSpan value={a.title} />
              {/*<OptionalSpan value={a.aristocraticTitle} />*/}
              {/*<OptionalSpan value={a.jobTitle} />*/}
              <OptionalSpan value={a.honorific} />
              <OptionalSpan value={a.firstName} />
              {/*<OptionalSpan value={a.secondName} />*/}
              <OptionalSpan value={a.lastName} />
              {/*<OptionalSpan value={a.secondLastName} />*/}
            </div>
            {/*  <OptionalDiv value={a.companyName1} />
        <OptionalDiv value={a.companyName2} />*/}
            {/*  <OptionalDiv value={a.addressLine1}/>
      <OptionalDiv value={a.addressLine2}/>*/}
            {/*<OptionalDiv value={a.addressLine3} />*/}
            {/*<OptionalDiv value={a.postBox} />*/}
            {/*<OptionalDiv value={a.mainDivision} />*/}
            {/*<OptionalDiv value={a.mainDivisionName} />*/}
            {/*<OptionalDiv value={a.subDivision} />*/}
            {/*<OptionalDiv value={a.subDivisionName} />*/}

            <OptionalDiv value={a.email} />
            {/*<OptionalDiv value={a.phoneMobile} />*/}
            {/*<OptionalDiv value={a.phoneHome} />*/}
            <OptionalDiv value={a.phoneBusiness} />
            {/*
      <OptionalDiv value={a.urn} />
*/}

            {/*<OptionalDiv value={a.phoneBusinessDirect} />*/}
            {/*<OptionalDiv value={a.fax} />*/}
          </div>
        </>
      )}
    </>
  )
}

function AddressFieldsB2C({ a }: { a: ExtendedAddressRO }) {
  return (
    <>
      {a && (
        <>
          <div className="flex flex-col items-start gap-y-px">
            <div className="flex flex-row flex-wrap gap-x-[0.2rem]">
              <OptionalSpan value={a.title} />
              {/*<OptionalSpan value={a.aristocraticTitle} />*/}
              {/*<OptionalSpan value={a.jobTitle} />*/}
              <OptionalSpan value={a.honorific} />
              <OptionalSpan value={a.firstName} />
              {/*<OptionalSpan value={a.secondName} />*/}
              <OptionalSpan value={a.lastName} />
              {/*<OptionalSpan value={a.secondLastName} />*/}
            </div>

            <OptionalDiv value={a.addressLine1} />
            <OptionalDiv value={a.addressLine2} />
            {/*<OptionalDiv value={a.addressLine3} />*/}
            {/*<OptionalDiv value={a.postBox} />*/}
            {/*<OptionalDiv value={a.mainDivision} />*/}
            {/*<OptionalDiv value={a.mainDivisionName} />*/}
            {/*<OptionalDiv value={a.subDivision} />*/}
            {/*<OptionalDiv value={a.subDivisionName} />*/}
            <div className="flex flex-row gap-x-[0.2rem]">
              {/*<OptionalSpan value={a.countryCode} />*/}
              <OptionalSpan value={a.postalCode} />
              <OptionalSpan value={a.city} />
            </div>
            <OptionalSpan value={a.country} />
            {/*
      <OptionalDiv value={a.urn} />
*/}

            {/*<OptionalDiv value={a.phoneBusinessDirect} />*/}
            {/*<OptionalDiv value={a.fax} />*/}
          </div>
          <div className="flex flex-col items-start gap-y-px">
            <OptionalDiv value={a.email} />
            {/*<OptionalDiv value={a.phoneMobile} />*/}
            {/*<OptionalDiv value={a.phoneHome} />*/}
            <OptionalDiv value={a.phoneBusiness} />
            {/*  <OptionalDiv value={a.companyName1} />
        <OptionalDiv value={a.companyName2} />*/}
          </div>
        </>
      )}
    </>
  )
}

export function AddressFields(props: AddressFieldsProps) {
  const a = props.address ?? {}

  return (
    <div className={"flex w-full flex-col justify-between gap-2"}>
      <div className={cn("grid w-full grid-cols-1 gap-x-4 gap-y-2 overflow-hidden md:grid-cols-2", props.className)}>
        {props.isB2B ? <AddressFieldsB2B a={props.address} /> : <AddressFieldsB2C a={props.address} />}
      </div>
      {props.showEligibleIcons && (
        <div className={"flex flex-row gap-0.5"}>
          {a.invoiceToAddress && (
            <TooltipProvider delayDuration={50} skipDelayDuration={100}>
              <Tooltip>
                <TooltipTrigger asChild>
                  <FileTextIcon className={"h-4 w-fit text-gray-500"} />
                </TooltipTrigger>
                <TooltipContent className={"rounded-lg p-4"}>
                  {props.showEligibleIcons.invoiceAddressTooltip}
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}

          {a.shipToAddress && (
            <TooltipProvider delayDuration={50} skipDelayDuration={100}>
              <Tooltip>
                <TooltipTrigger asChild>
                  <TruckIcon className={"h-4 w-fit text-gray-500"} />
                </TooltipTrigger>
                <TooltipContent className={"rounded-lg p-4"}>
                  {props.showEligibleIcons.shippingAddressTooltip}
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </div>
      )}
    </div>
  )
}
